import { reactive } from 'vue'

const STORAGE_KEY = 'sidebarCollapsed'

export const sidebarState = reactive({
  collapsed: localStorage.getItem(STORAGE_KEY) === 'true',
  toggle() {
    this.collapsed = !this.collapsed
    localStorage.setItem(STORAGE_KEY, this.collapsed ? 'true' : 'false')
  },
  set(value) {
    this.collapsed = value
    localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false')
  },
})
